import { render, staticRenderFns } from "./SapSyncMenus.vue?vue&type=template&id=bf9d40fa"
import script from "./SapSyncMenus.vue?vue&type=script&lang=js"
export * from "./SapSyncMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports